import {
  getZrmListingInfo,
  getZrmRentalsLead,
  getZrmUserInfo,
  type ZrmClickstreamLead,
  type ZrmClickstreamListing,
} from '@zg-rentals/clickstream';
import { trackListingEvent } from '../../analytics';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_LOCATION, TRIGGER_OBJECT, TRIGGER_TYPE } from './globals';
import type { ZrmClickstreamUserOrNull } from '../../analytics/types';

// https://dataportal.zillowgroup.net/event-registry/9209
export const CLICK_ON_VIEW_IN_MESSAGES_ICON_EVENT_TYPE_ID = '9209';
export const emitClickOnViewInMessagesIcon = (
  user: ZrmClickstreamUserOrNull,
  listing: ZrmClickstreamListing,
  lead?: ZrmClickstreamLead | null,
) =>
  trackListingEvent({
    envelope: {
      event_type_id: CLICK_ON_VIEW_IN_MESSAGES_ICON_EVENT_TYPE_ID,
      event_type_version_id: '5',
      event_template_id: '628',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.LeadManagementPage,
      trigger_source_nm: 'button_to_view_inbox',
      trigger_object_nm: TRIGGER_OBJECT.MessageWindow,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ManageLead,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(listing),
    ...getZrmRentalsLead(lead),
  });
